import { ADD_SNACKBAR_NOTIFICATION, REMOVE_SNACKBAR_NOTIFICATION } from 'reducers/actions-types';
import { sortBy } from 'lodash';

/**
 * Make sure that the notifications with the highest priority come always as first
 * @param {array} notifications - notifications list
 * @returns {array} sorted array
 */
const sort = notifications => sortBy(notifications, 'priority');

export default function snackbarReducer(state = {
    items: [],
}, { type, notification }) {
    switch (type) {
        case ADD_SNACKBAR_NOTIFICATION:
            return Object.assign({}, state, {
                items: sort([notification, ...state.items]),
            });
        case REMOVE_SNACKBAR_NOTIFICATION:
            return Object.assign({}, state, {
                items: sort(state.items.reduce((curr, item) => {
                    if (notification.id !== item.id) {
                        curr.push(item);
                    }
                    return curr;
                }, [])),
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/snackbar/index.js